import { render, staticRenderFns } from "./AlbumListContainer.vue?vue&type=template&id=c0b4214a&scoped=true"
import script from "./AlbumListContainer.vue?vue&type=script&lang=js"
export * from "./AlbumListContainer.vue?vue&type=script&lang=js"
import style0 from "./AlbumListContainer.vue?vue&type=style&index=0&id=c0b4214a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b4214a",
  null
  
)

export default component.exports